import { Box, CircularProgress } from "@mui/material";

/**
 * Full-screen loading state while the app can't render yet (auth check,
 * session load, reload). Reference: twosion-ui src/components/PageLoader.tsx.
 */
export function PageLoader({ label }: { label: string }) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh" }}>
      <CircularProgress aria-label={label} />
    </Box>
  );
}
